// extracted by mini-css-extract-plugin
export default {"box":"HomeCarouselCard_box__HWBm8","img_Container":"HomeCarouselCard_img_Container__vlrcw"};